// Block 6: Reservation and Usage Time Section
export { default as ReservationUsageChart } from './ReservationUsageChart';

// Block 7: Unused and Released Time Section
export { default as UnusedReleasedTimeChart } from './UnusedReleasedTimeChart';

// Block 8: Unused Organizers Chart
export { default as UnusedOrganizersChart } from './UnusedOrganizersChart';

// Block 9 & 10: People Rate Charts (combined section with pie chart)
export { default as PeopleRateChart } from './PeopleRateChart';

